/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AG_GRID_CONFIG } from '../../config/constants';

@Injectable()
export class DistributorSupportService {
  private url: string = environment.host;
  private selectedDistributor: any = {};
  private distributorDetails: Array<any> = [];
  private layOUtUrl: string = environment.host + '/layout';
  private searchParticipantUrl: string = environment.host + '/participant/search';
  private searchOrganizationUrl: string = environment.host + '/organizationalUnit/search';
  private lineUrl: string = environment.host + '/participant/';
  private planUrl: string = environment.host + '/plan/';
  private reportUrl: string = environment.host + '/report/DistributorSupport';
  private getAllParticipantStatusUrl: string = environment.host + '/participantstatus';
  private groupMetadataUrl: string = environment.host + '/participant/metadata';
  private responsorDateUrl: string = environment.host + '/participant/responsorDate';
  private masterColumnsAndFiltersUrl: string = environment.host + '/compensation/analytics/metadata';
  private loadVgmurl: string = environment.host + '/overrides/vgm/';
  private searchTLParticipantUrl: string = environment.host + '/participant/searchTL';
  private addTLToVIPGroupUrl: string = environment.host + '/participant/addToVipGroup';
  private deleteTLFromVIPGroupUrl: string = environment.host + '/participant/deleteFromVIPGroup';
  private distributorClientId: any;
  private overrideCardMetadata: any;
  private overrideCardPeriodsMetadata: any;
  private overrideVGMCardMetadata: any;
  private overrideReVGMCardMetadata: any;
  private overrideReprocessCardMetadata: any;
  private overriderId: any;
  private isOverrideDelete = false;
  private selectedOverrideDetails: any;
  private overrideName: any;
  private formattedDistDetails: any;
  private formattedPriceDtls: any;
  private participantStatus: any;
  private shEditSelections: any = {};
  private pddEditSelections: any = {};
  private editCompPlanSelections: any = {};
  private distributorName: any;
  private groupCompDistrCardData: any = {};
  public overrideVGMName: any;
  public selectedVGMOverrideDetails: any;
  private flagsMetaUrl: string = environment.host + '/flag/metadata';
  private flags: any = {};
  private carProgramUrl: string = environment.host + '/carProgram/';
  private priorPeriodUrl: string = environment.host + '/period/priorPeriod/1';
  private notesUrl: string = environment.host + '/participant/note';
  public flagSelData = new EventEmitter<any>();
  public terminationDate: any;
  private participantUrl: string = environment.host + '/updateadvisor/';
  public getGlobalSettingsUrlTabType: string = environment.host + '/globalSettings';

  constructor(private http: HttpClient) {}

  public reset() {
    this.overriderId = '';
    this.overrideName = '';
    this.selectedOverrideDetails = null;
  }

  
  public getAllProductCategoriesTabType() {
    const url = environment.host + '/productCategory?tabType=' + 'productcategory/adcard';
    return this.http.get(url).toPromise();
  }

  public getPeriod() {
    return this.http.get(this.url.toString() + '/period').toPromise();
  }

  public setSelectedDistributor(distributor: any) {
    this.selectedDistributor = distributor;
  }

  public getSelectedDistributor() {
    return this.selectedDistributor;
  }

  public getDistributorDetailsById(clientId: any) {
    return this.http.get(this.lineUrl + clientId).toPromise();
  }

  public setDistributorData(distributorDetails: any) {
    this.distributorDetails = distributorDetails;
  }

  public getDistributorData() {
    return this.distributorDetails;
  }

  public filterGloballyByEnteredValue(searchText: any, isFullClientId = false, pageMaxId?: any, pageSize?: any, hideLoader?: any, periodName?: any) {
    // let queryParams = '?searchText=' + encodeURIComponent(searchText) + '&pageMaxId=' + (pageMaxId === undefined || pageMaxId === null ? AG_GRID_CONFIG.startingPageMaxId : pageMaxId) + '&size=' + (pageSize || AG_GRID_CONFIG.recordsPerPage);
    // const headers = new Headers();
    // headers.append('hideLoader', hideLoader);
    // const options = new RequestOptions({ headers: headers });
    // return this.http.get(this.searchDistributorUrl + queryParams, options).toPromise();

    const periodNameVal = periodName ? periodName : '',
      queryParams =
        '?&pageMaxId=' +
        (pageMaxId === undefined || pageMaxId === null ? AG_GRID_CONFIG.startingPageMaxId : pageMaxId) +
        '&size=' +
        (pageSize || AG_GRID_CONFIG.recordsPerPage) +
        '&searchStr=' +
        encodeURIComponent(searchText) +
        '&periodName=' +
        periodNameVal +
        '&isFullClientId=' +
        isFullClientId;
    const headers = new HttpHeaders();
    headers.append('hideLoader', hideLoader);
    //const options = new RequestOptions({ headers: headers });
    return this.http.get(this.searchParticipantUrl + queryParams, { headers: headers }).toPromise();
  }

  public filterGlobalOrganizationValue(searchText: any, isOrganizationId = false, pageMaxId?: any, pageSize?: any, hideLoader?: any, periodName?: any) {
    const periodNameVal = periodName ? periodName : '',
      queryParams =
        '?&pageMaxId=' +
        (pageMaxId === undefined || pageMaxId === null ? AG_GRID_CONFIG.startingPageMaxId : pageMaxId) +
        '&size=' +
        (pageSize || AG_GRID_CONFIG.recordsPerPage) +
        '&searchStr=' +
        encodeURIComponent(searchText) +
        '&periodName=' +
        periodNameVal +
        '&isOrganizationId=' +
        isOrganizationId;
    const headers = new HttpHeaders();
    headers.append('hideLoader', hideLoader);
    //const options = new RequestOptions({ headers: headers });
    return this.http.get(this.searchOrganizationUrl + queryParams, { headers: headers }).toPromise();
  }

  public searchParticipant(searchText: any) {
    const queryParams = environment.host + '/global/search?searchText=' + encodeURIComponent(searchText);
    return this.http.get(queryParams.toString()).toPromise();
  }

  public getOverridesMetadata(clientId: any) {
    const overrideMetadataUrl = this.lineUrl + clientId + '/overrides/metadata';
    return this.http.get(overrideMetadataUrl).toPromise();
  }

  public getReprocessAllverridesMetadata(clientId: any) {
    const overrideReprocessMetadataUrl = this.lineUrl + clientId + '/overrides';
    return this.http.get(overrideReprocessMetadataUrl).toPromise();
  }

  public getReprocessOverridesMetadata(clientId: any) {
    const overrideReprocessMetadataUrl = this.lineUrl + clientId + '/overrides/metadata?reprocess=true';
    return this.http.get(overrideReprocessMetadataUrl).toPromise();
  }

  public getVGMOverridesMetadata(clientId: any) {
    const overrideMetadataUrl = this.lineUrl + clientId + '/overrides/vgm/metadata';
    return this.http.get(overrideMetadataUrl).toPromise();
  }

  public getVReGMOverridesMetadata(clientId: any) {
    const overrideMetadataUrl = this.lineUrl + clientId + '/overrides/vgm/metadata?reprocess=true';
    return this.http.get(overrideMetadataUrl).toPromise();
  }

  public getReprocessLogs(clientId: any, period: any) {
    const reprocessLogUrl = this.lineUrl + clientId + '/reprocess/transactions/' + period;
    return this.http.get(reprocessLogUrl).toPromise();
  }

  public getLeadersData(planId: any) {
    const leadersDataUrl = this.planUrl + planId + '/title/leaderrules';
    return this.http.get(leadersDataUrl).toPromise();
  }

  public setDistributorClientId(clientId: any) {
    this.distributorClientId = clientId;
  }

  public getDistributorClientId() {
    return this.distributorClientId;
  }

  public setDistributorName(distributorName: any) {
    this.distributorName = distributorName;
  }

  public getDistributorName() {
    return this.distributorName;
  }

  public setOverrideCardMetadata(data: any) {
    this.overrideCardMetadata = data;
  }

  public getOverrideCardMetadata() {
    return this.overrideCardMetadata;
  }

  public setOverridesMetaPeriods(data: any) {
    this.overrideCardPeriodsMetadata = data;
  }

  public getOverridesMetaPeriods() {
    return this.overrideCardPeriodsMetadata;
  }

  public setReprocessOverrideCardMetadata(data: any) {
    this.overrideReprocessCardMetadata = data;
  }

  public getReprocessOverrideCardMetadata() {
    return this.overrideReprocessCardMetadata;
  }

  public setVGMOverrideCardMetadata(data: any) {
    this.overrideVGMCardMetadata = data;
  }

  public getVGMOverrideCardMetadata() {
    return this.overrideVGMCardMetadata;
  }

  public setReVGMOverrideCardMetadata(data: any) {
    this.overrideReVGMCardMetadata = data;
  }

  public getReVGMOverrideCardMetadata() {
    return this.overrideReVGMCardMetadata;
  }

  public setParitipantOverrideId(overrideId: any) {
    this.overriderId = overrideId;
  }

  public getParitipantOverrideId() {
    return this.overriderId;
  }

  public setParticipantOverrideDelete(isOverrideDelete: boolean) {
    this.isOverrideDelete = isOverrideDelete;
  }

  public isParticipantOverrideDelete() {
    return this.isOverrideDelete;
  }

  public setSelectedOverrideDetailsById(data: any) {
    this.selectedOverrideDetails = data;
  }

  public getSelectedOverrideDetailsById() {
    return this.selectedOverrideDetails;
  }

  public setSelectedVGMOverrideDetailsById(data: any) {
    this.selectedVGMOverrideDetails = data;
  }

  public getSelectedVGMOverrideDetailsById() {
    return this.selectedVGMOverrideDetails;
  }

  public setSelectedOverrideName(overrideName: any) {
    this.overrideName = overrideName;
  }

  public getSelectedOverrideName() {
    return this.overrideName;
  }

  public setSelectedVGMOverrideName(overrideName: any) {
    this.overrideVGMName = overrideName;
  }

  public getSelectedVGMOverrideName() {
    return this.overrideVGMName;
  }

  public getAllPariticipantOverrides(clientId: any) {
    const overrideMetadataUrl = this.lineUrl + clientId + '/period/overrides/';
    return this.http.get(overrideMetadataUrl).toPromise();
  }

  public savePariticipantOverrideCard(clientId: any, requestPayLoad: any, reprocess: any) {
    let saveParticipantOverrideUrl;
    if (reprocess) {
      saveParticipantOverrideUrl = this.lineUrl + clientId + '/overrides?reprocess=true';
    } else {
      saveParticipantOverrideUrl = this.lineUrl + clientId + '/overrides/';
    }
    return this.http.post(saveParticipantOverrideUrl, requestPayLoad).toPromise();
  }

  public updatePariticipantOverrideCard(clientId: any, selectedOverrideId: any, requestPayLoad: any, reprocess: any) {
    let updateParticipantOverrideUrl;
    if (reprocess) {
      updateParticipantOverrideUrl = this.lineUrl + clientId + '/overrides/' + selectedOverrideId + '?reprocess=true';
    } else {
      updateParticipantOverrideUrl = this.lineUrl + clientId + '/overrides/' + selectedOverrideId;
    }
    return this.http.put(updateParticipantOverrideUrl, requestPayLoad).toPromise();
  }

  public deletePariticipantOverrideCard(clientId: any, selectedOverrideId: any, reprocess: any) {
    let deleteParticipantOverrideUrl;
    if (reprocess) {
      deleteParticipantOverrideUrl = this.lineUrl + clientId + '/overrides/' + selectedOverrideId + '?reprocess=true';
    } else {
      deleteParticipantOverrideUrl = this.lineUrl + clientId + '/overrides/' + selectedOverrideId;
    }
    return this.http.delete(deleteParticipantOverrideUrl).toPromise();
  }

  public getQualifiedPeriods(clientId: any) {
    const qualifiedPeriodUrl = this.lineUrl + clientId + '/qualified/' + 4;
    return this.http.get(qualifiedPeriodUrl).toPromise();
  }

  public getPlanSummaryInfo(planId: any) {
    const planUrl = this.planUrl + planId + '/summary';
    return this.http.get(planUrl).toPromise();
  }

  public getPlanSummaryInfoNewURL(planId: any) {
    const planUrl = this.planUrl + planId + '/summary/adcard';
    return this.http.get(planUrl).toPromise();
  }

  public getReportDefinition() {
    const url = this.reportUrl;
    return this.http.get(url).toPromise();
  }

  public setFormattedDistributorDtls(data: any) {
    this.formattedDistDetails = data;
  }

  public getFormattedDistributorDtls() {
    return this.formattedDistDetails;
  }

  public setFormattedPriceDtls(data: any) {
    this.formattedPriceDtls = data;
  }

  public getFormattedPriceDtls() {
    return this.formattedPriceDtls;
  }

  public setEditPddSelections(data: any) {
    this.pddEditSelections = data;
  }

  public getEditPddSelections() {
    return this.pddEditSelections;
  }

  public setEditSHSelections(data: any) {
    this.shEditSelections = data;
  }

  public getEditSHSelections() {
    return this.shEditSelections;
  }

  //to set data for status and date selected in edit status modal
  public setParticipantStatusSelections(element: any) {
    this.participantStatus = element;
  }

  //to get the set data from edit modal to confirm modal in participant status
  public getParticipantStatusSelections() {
    return this.participantStatus;
  }

  public updateCardDetails(cardDtls: any, id: any) {
    return this.http.put(this.lineUrl.toString() + id + '\\update', cardDtls).toPromise();
  }

  public updateNewMemberDetails(newMemberDtls: any, id: any) {
    return this.http.put(this.lineUrl.toString() + id + '\\newmember', newMemberDtls).toPromise();
  }

  public setEditCompPlanSelections(data: any) {
    this.editCompPlanSelections = data;
  }

  public getEditCompPlanSelections() {
    return this.editCompPlanSelections;
  }

  // setGroupCompDistrCardData(data) {
  //   this.groupCompDistrCardData = data;
  // }
  // getGroupCompDistrCardData() {
  //   return this.groupCompDistrCardData;
  // }

  public getAllParticipantStatus() {
    return this.http.get(this.getAllParticipantStatusUrl.toString()).toPromise();
  }

  public updateParticipantStatus(clientId: any, statusId: any, payload: any) {
    return this.http.put(this.lineUrl.toString() + clientId + '\\status/' + statusId, payload).toPromise();
  }

  public updateParticipantFlag(clientId: any, requestPayLoad: any, reprocessed: any) {
    const updateParticipantFlagUrl = this.lineUrl + clientId + '/flags?reprocess=' + reprocessed;
    return this.http.put(updateParticipantFlagUrl, requestPayLoad).toPromise();
  }

  updateUserLayout(payload: any) {
    return this.http.put(this.layOUtUrl, payload).toPromise();
  }

  public updateCarProgram(payload: any, clientId: any) {
    return this.http.post(this.carProgramUrl + clientId + '/enrollment', payload).toPromise();
  }

  public getGroupMetadata() {
    const groupMetadataUrl = this.groupMetadataUrl;
    return this.http.get(groupMetadataUrl).toPromise();
  }

  //column sets
  public loadMasterColumnsAndFilters() {
    return this.http.get(this.masterColumnsAndFiltersUrl).toPromise();
  }

  public getFastStartBonusDetails(clientId: any) {
    const url = this.lineUrl + clientId + '/fastStartBonus';
    return this.http.get(url).toPromise();
  }

  public getCompensationMetadata() {
    const url = this.url + '/compensation/metadata';
    return this.http.get(url).toPromise();
  }

  public getCompensationMetadataTabType() {
    const url = this.url + '/compensation/metadata?tabType=' + 'compensationPage/adcard';
    return this.http.get(url).toPromise();
  }

  public getVgmDetailsByClientID(clientID: any) {
    const loadVgmurl = this.loadVgmurl + clientID;
    return this.http.get(loadVgmurl.toString()).toPromise();
  }

  public getAllFlags() {
    return this.http.get(this.flagsMetaUrl.toString()).toPromise();
  }

  public getAllFlagsTabType() {
    const URL=environment.host + '/flag/metadata?tabType=' + 'flagpage/adcard';
    return this.http.get(URL.toString()).toPromise();
  }

  public setFlagsData(flags: any) {
    this.flags = flags;
  }

  public getFlagsData() {
    return this.flags;
  }

  public getAllCarTypes() {
    return this.http.get(environment.host + '/cartype').toPromise();
  }

  public getCarEnrollmentDtls(clientId: any, tierCode?: string) {
    if (tierCode) {
      return this.http.get(this.carProgramUrl + clientId + '/' + tierCode).toPromise();
    } else {
      return this.http.get(this.carProgramUrl + clientId).toPromise();
    }
  }

  public updateRescindDetails(clientId: any, period: any) {
    const updateRescindUrl = this.lineUrl + clientId + '/rescind?periodName=' + period;
    return this.http.post(updateRescindUrl, null).toPromise();
  }

  public getOrdersByClientId(clientId: any, orderPeriod: any) {
    const payload: any = {
      filters: [],
      sourceTypes: ['Order', 'VolumeTransfer']
    };
    if (orderPeriod) {
      payload.filters.push({
        name: 'monthly',
        options: [
          {
            id: orderPeriod.id,
            name: orderPeriod.name
          }
        ]
      });
    }
    return this.http.post(environment.host + '/participant/' + clientId + '/OrderDetails', payload).toPromise();
  }

  public getPreviousPeriods() {
    return this.http.get(this.priorPeriodUrl.toString()).toPromise();
  }

  public getAllTitles(planId: any) {
    const titleurl = this.planUrl.toString() + planId + '/title/adcard';
    return this.http.get(titleurl).toPromise();
  }

  public getAllPlanVolumeDefinitions(planId: any) {
    const plan = this.planUrl.toString() + planId + '/volume-definitions';
    return this.http.get(plan).toPromise();
  }

  public getAllPlanVolumeDefinitionsTabType(planId: any) {
    const plan = this.planUrl.toString() + planId + '/volume-definitions?tabType=' + 'volumedef/adcard';
    return this.http.get(plan).toPromise();
  }

  public getAchievementsData(participantId: any, period: any) {
    const url = environment.host + '/participant/' + participantId + '/achievedata?period=' + period;
    return this.http.get(url).toPromise();
  }

  public updateLegacyAllowedEndDate(clientId: any, payload: any) {
    const url = environment.host + '/participant/' + clientId;
    return this.http.put(url, payload).toPromise();
  }

  public updateResponsorDate(payload: any) {
    return this.http.put(this.responsorDateUrl, payload).toPromise();
  }

  public getCompanyConfigDDCards() {
    const url = environment.host + '/participant/ddCards';
    return this.http.get(url).toPromise();
  }

  public getPDF(currentPeriod: any, clientId: any, emailFlag: boolean) {
    const url = environment.host + '/download/' + currentPeriod + '/' + clientId + '?emailFlag=' + emailFlag;

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(url, { headers: headers, responseType: 'blob' }).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/pdf' });
      })
    );
  }

  public getBonusesAndEarnings(period: any, clientId: any) {
    const url = environment.host + '/bonus/earning/' + clientId + '/' + period;
    return this.http.get(url).toPromise();
  }

  public getBonusAdjustments(period: any, clientId: any) {
    const url = environment.host + '/bonus/adjustment/' + clientId + '/' + period;
    return this.http.get(url).toPromise();
  }

  public updateBankedPayment(clientId: any) {
    const url = environment.host + '/carProgram/' + clientId + '/isBankedPayment';
    return this.http.put(url, {}).toPromise();
  }

  public getCompensations() {
    return this.http.get(this.url.toString() + '/compensation/global').toPromise();
  }

  public getCompensationsTabType() {
    return this.http.get(this.url.toString() + '/compensation/global?tabType=compensationPage/adcard').toPromise();
  }

  public updateDistributor(payload: any, clientId?: any) {
    let url = '';
    if (payload.operation === 'TitleUpdate') {
      url = environment.host + '/demo/participant/' + clientId + '/update';
    } else if (payload.operation === 'PrebreakoutPriceTier') {
      url = environment.host + '/demo/participant/' + clientId + '/update/prebreakoutpricetier';
    } else if (payload.operation === 'Fasttrack') {
      url = environment.host + '/demo/update/bonus';
      payload.bonusType = 'FTB';
    } else if (payload.operation === 'CarProgram') {
      url = environment.host + '/demo/update/bonus';
      payload.bonusType = 'CAR';
    }

    // delete operation
    delete payload.operation;

    return this.http.put(url, payload).toPromise();
  }

  getTitleDetails(planId: string, rank: number, clientId: string) {
    const url = environment.host + '/plan/' + planId + '/title/' + rank + '/' + clientId;
    return this.http.get(url).toPromise();
  }

  public getNextTitleForChallengeProgram(planId: string, rank: number) {
    const url = environment.host + '/plan/' + planId + '/title/immediate/' + rank;
    return this.http.get(url).toPromise();
  }

  public saveChallengeProgramByTitle(clientId: string, payload: any) {
    const url = environment.host + '/participant/' + clientId + '/challengeProgram';
    return this.http.post(url, payload).toPromise();
  }

  public saveChallengeProgramEndDate(clientId: string, payload: any) {
    const url = environment.host + '/program/' + clientId + '/programCardUpdate';
    return this.http.post(url, payload).toPromise();
  }

  public getChallengeProgramByTitle(clientId: string, rank: string) {
    const url = environment.host + '/participant/' + clientId + '/challengeProgram/' + rank;
    return this.http.get(url).toPromise();
  }

  public saveEarningProgramByTitle(clientId: string, payload: any) {
    const url = environment.host + '/program/' + clientId + '/programCard';
    return this.http.post(url, payload).toPromise();
  }

  public updateOrderDetails(payload: any, orderId: string) {
    const url = environment.host + '/transaction/' + orderId;
    return this.http.put(url, payload).toPromise();
  }

  public getDistributorNotes(clientID: any) {
    const url = environment.host + '/' + clientID + '/note';
    return this.http.get(url).toPromise();
  }

  public saveNote(payload: any) {
    return this.http.post(this.notesUrl, payload).toPromise();
  }

  public getChallengeProgramMetaData() {
    const url = environment.host + '/challengeProgramMetadata';
    return this.http.get(url).toPromise();
  }

  public getChallengeProgramMetaDataTabType() {
    const url = environment.host + '/challengeProgramMetadata?tabType=challengeprogrammetadata/adcard';
    return this.http.get(url).toPromise();
  }

  public getSNHDistDetails(participantID: any) {
    const url = environment.host + '/participant/' + participantID + '/snh';
    return this.http.get(url).toPromise();
  }

  public getRedeemIncentives(clientId: string) {
    const url = environment.host + '/incentive/reward/redeem/details/' + clientId;
    return this.http.get(url).toPromise();
  }

  public sendRedeemRequest(payload: any) {
    const redeemUrl = environment.host + '/incentive/reward/redeem';
    return this.http.post(redeemUrl, payload).toPromise();
  }

  public getLegacyOrders(clientId: string) {
    const url = environment.host + '/legacyOrder/' + clientId;
    return this.http.get(url).toPromise();
  }

  public getAdhocPaymentMetadata() {
    const url = environment.host + '/adhocPaymentMetadata';
    return this.http.get(url).toPromise();
  }

  public getAdHocPayments(volumePeriod: string, clientId: string) {
    const url = environment.host + '/adhocPayment/' + volumePeriod + '/' + clientId;
    return this.http.get(url).toPromise();
  }

  public makeAdhocPayment(volumePeriod: string, clientId: string, payload: any) {
    const url = environment.host + '/adhocPayment/' + volumePeriod + '/' + clientId;
    return this.http.post(url, payload).toPromise();
  }

  public cancelAdhocPayment(volumePeriod: string, clientId: string, payload: any) {
    const url = environment.host + '/adhocPayment/' + volumePeriod + '/' + clientId;
    return this.http.post(url, payload).toPromise();
  }

  public getCalculatedEffectiveDate(clientId: any) {
    const url = environment.host + '/participant/' + clientId + '/responsorDate';
    return this.http.get(url).toPromise();
  }

  public getOverridesMetaPeriodsList() {
    const url = environment.host + '/period?planPeriodRequest=CurrentNext';
    return this.http.get(url).toPromise();
  }

  public getCommissionVolumes(clientId: any, period: any, isRealTime: any) {
    const url = environment.host + '/participant/' + clientId + '/planPeriod/' + period + '?isRealtime=' + isRealTime;
    return this.http.get(url).toPromise();
  }

  public promoteRDemoteTitle(payload: any, clientId: string) {
    const url = this.lineUrl + clientId + '/titleHistory';
    return this.http.post(url, payload).toPromise();
  }

  public getIncentiveStatus(clientId: string) {
    const url = environment.host + '/incentive/program/status/' + clientId;
    return this.http.get(url).toPromise();
  }

  public getIncentiveProgramList(planId: string|number) {
    const url = environment.host + '/incentive/' + planId;
    return this.http.get(url).toPromise();
  }

  public getPromoteDemoteScheduleJobs(clientId: string) {
    const url = environment.host + '/titlePromoteDemoteSchedule/' + clientId;
    return this.http.get(url).toPromise();
  }

  public getChangeSponsorScheduledJobs(clientId: string, periodName: any) {
    const url = environment.host + '/participant/' + clientId + '/sponsorship/' + periodName;
    return this.http.get(url).toPromise();
  }

  public cancelPromoteDemoteScheduledJob(scheduledJobID: any, comment: any) {
    const payload = {
      comment: comment
    };
    const url = environment.host + '/cancelTitlePromoteDemoteSchedule/' + scheduledJobID;
    return this.http.post(url, payload).toPromise();
  }

  public cancelChangeSponsorScheduledJob(scheduledJobID: any, comment: any) {
    const payload = {
      comment: comment
    };
    const url = environment.host + '/participant/cancelsponsorship/' + scheduledJobID;
    return this.http.post(url, payload).toPromise();
  }
  
  public makeVolumeAdjustment(payload: any) {
    const createUrl = environment.host + '/volumeAdjustment?reportType=VAC';
    const updateUrl = environment.host + '/volumeAdjustment?reportType=VAU';
    if (payload.id) { 
      return this.http.put(updateUrl, payload).toPromise();
    } else {
      return this.http.post(createUrl, payload).toPromise();
    }
  }

  public getVolumeAdjustments(volumePeriod: string, clientId: string) {
    const url = environment.host + '/volumeAdjustment/' + clientId + '/' + volumePeriod;
    return this.http.get(url).toPromise();
  }

  // cancelVolumeAdjustment(adjustmentId) {
  //   const url = environment.host + '/volumeAdjustment/' + adjustmentId;
  //   return this.http.post(url, null).toPromise();
  // }
  
  public deleteOrganizationUnit(clientID: any, orgUnitId: any) {
    const url = this.lineUrl + clientID + '/organization/' + orgUnitId;
    return this.http.delete(url).toPromise();
  }

  public addOrganizationUnit(clientID: any, orgUnitId: any) {
    const url = this.lineUrl + clientID + '/organization/' + orgUnitId;
    return this.http.post(url,'').toPromise();
  }

  public setTerminationDate(terminationDate: any) {
    this.terminationDate = terminationDate;
  }

  public getTerminationDate() {
    return this.terminationDate;
  }

  //VCE-22209 STOP CP
  public stopCP(clientId: string, payload: any) {
    const url = environment.host + '/program/' + clientId + '/stopChallengeProgram';
    return this.http.post(url, payload).toPromise();
  }

  //VCE-24551 Recalculate & send to integration
  public recalcualteCP(clientID: any, programId: any) {
    const url = environment.host + '/cpRecalculate/' + programId + '/' + clientID;
    return this.http.post(url, {}).toPromise();
  }

  public sendCPToIntegration(clientID: any, programId: any) {
    const url = environment.host + '/cpToIntegration/' + programId + '/' + clientID;
    return this.http.post(url, {}).toPromise();
  }
  // VCE-24551 -end of Recalcualte & send to integratio

  /* VCE-28504 - Add TL to VIP Group */
  //API to search only TLs
  public searchTLs(searchText: any, isFullClientId = false, pageMaxId?: any, pageSize?: any, hideLoader?: any, periodName?: any) {      
    const periodNameVal = periodName ? periodName : '',
      queryParams =
        '?&pageMaxId=' +
        (pageMaxId === undefined || pageMaxId === null ? AG_GRID_CONFIG.startingPageMaxId : pageMaxId) +
        '&size=' +
        (pageSize || AG_GRID_CONFIG.recordsPerPage) +
        '&searchStr=' +
        encodeURIComponent(searchText) +
        '&periodName=' +
        periodNameVal +
        '&isFullClientId=' +
        isFullClientId;
    const headers = new HttpHeaders();
    headers.append('hideLoader', hideLoader);      
    return this.http.get(this.searchTLParticipantUrl + queryParams, { headers: headers }).toPromise();
  }

  // API to add TL to the VIP Group
  public addTLToVIPGroup(payload: any) {
    return this.http.post(this.addTLToVIPGroupUrl, payload).toPromise();
  }

  //Delete API for removing TL from VIP Group
  public deleteTLfromVIPGroup(payload: any) {
    return this.http.put(this.deleteTLFromVIPGroupUrl, payload).toPromise();
  }

  public updateParticipant(clientId: any, payload: any){
    const url = this.participantUrl + clientId;
    return this.http.put(url, payload).toPromise();
  }

  public getGlobalSettingsTabType(payload: any) {
    if (payload) {
      const auth = btoa(payload.username + ':' + payload.password),
        headers = { Authorization: 'Basic ' + auth },
        code = btoa(payload.code);
      return this.http.get(this.getGlobalSettingsUrlTabType + `?code=${code}` + '&tabType=globalsettings/adcard', { headers: headers }).toPromise();
    } else {
      const URL=this.getGlobalSettingsUrlTabType+'?tabType=globalsettings/adcard';
      return this.http.get(URL).toPromise();
    }
  }
}
